import React, { useState, useEffect } from 'react';
import './CarWashModal.css';

const CarWashModal = ({ carWash, isOpen, onClose }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    if (isOpen) {
      setCurrentImageIndex(0);
      document.body.style.overflow = 'hidden';
    }

    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen || !carWash) return null;

  const sortedImages = carWash.images?.sort((a, b) => a.display_order - b.display_order) || [];

  const nextImage = () => {
    setCurrentImageIndex((prev) => 
      prev >= sortedImages.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => 
      prev <= 0 ? sortedImages.length - 1 : prev - 1
    );
  };

  return (
    <div className="modal-backdrop" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <style>{`.navbar { display: none !important; }`}</style>
      
      <div className="modal-container">
        <button className="modal-close" onClick={onClose}>
          ×
        </button>

        <div className="modal-content">
          {/* Galerija slika */}
          {sortedImages.length > 0 && (
            <div className="modal-gallery">
              <div className="gallery-container">
                <div className="gallery-images">
                  {sortedImages.map((image, index) => (
                    <img 
                      key={image.id}
                      src={image.image_url} 
                      alt={`${carWash.name} - ${index + 1}`}
                      className={`gallery-image ${index === currentImageIndex ? 'active' : ''}`}
                      style={{ transform: `translateX(${(index - currentImageIndex) * 100}%)` }}
                    />
                  ))}
                </div>
                
                {sortedImages.length > 1 && (
                  <>
                    <button className="gallery-nav prev" onClick={prevImage}>‹</button>
                    <button className="gallery-nav next" onClick={nextImage}>›</button>
                    
                    <div className="gallery-dots">
                      {sortedImages.map((_, index) => (
                        <button
                          key={index}
                          className={`dot ${index === currentImageIndex ? 'active' : ''}`}
                          onClick={() => setCurrentImageIndex(index)}
                        />
                      ))}
                    </div>
                  </>
                )}
              </div>
            </div>
          )}

          {/* Detalji perionice */}
          <div className="modal-details">
            <h2 className="modal-title">{carWash.Notes || carWash.name}</h2>
            
            <div className="details-grid">
              {/* Usisivači */}
              <div className="detail-item">
                <div className="detail-icon">🌀</div>
                <div className="detail-content">
                  <strong>Usisivači</strong>
                  <span>
                    {carWash.number_of_vacuums === 1 ? '1 usisivač' : 
                    `${carWash.number_of_vacuums || 0} usisivača`}
                  </span>
                </div>
              </div>

              {/* Aktivna pena */}
              {carWash.active_foam && (
                <div className="detail-item">
                  <div className="detail-icon">🫧</div>
                  <div className="detail-content">
                    <strong>Aktivna pena</strong>
                    <span>Dostupna na boksu</span>
                  </div>
                </div>
              )}

              {/* Sjaj za gume */}
              {carWash.tire_shine && (
                <div className="detail-item">
                  <div className="detail-icon">🛞</div>
                  <div className="detail-content">
                    <strong>Sjaj za gume</strong>
                    <span>Crnilo za gume</span>
                  </div>
                </div>
              )}

              {/* Miris za kola */}
              {carWash.car_fragrance && (
                <div className="detail-item">
                  <div className="detail-icon">🌲</div>
                  <div className="detail-content">
                    <strong>Miris za kola</strong>
                    <span>Dostupni mirisi</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarWashModal;